import { Link } from "react-router-dom";
import { BUSINESS, DOCTORS } from "@/data/site";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer data-testid="footer" className="bg-ink text-paper/80">
    <div className="mx-auto max-w-7xl px-5 md:px-8 py-16 grid gap-12 md:grid-cols-3">
      <div>
        <div className="mb-5">
          <Logo dark />
        </div>
        <p className="text-sm leading-relaxed max-w-xs">
          Studio di Medicina del Lavoro a Roma. Sorveglianza sanitaria, formazione e consulenza
          ai sensi del D.Lgs 81/08.
        </p>
      </div>
      <address className="not-italic text-sm leading-relaxed">
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-clinic-light mb-4">
          Sede
        </p>
        <a
          href={BUSINESS.mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-address-link"
          className="block hover:text-clinic-light transition-colors"
        >
          {BUSINESS.streetAddress}
          <br />
          {BUSINESS.postalCode} {BUSINESS.city} ({BUSINESS.region})
        </a>
        <a
          href={`mailto:${BUSINESS.email}`}
          data-testid="footer-email-link"
          className="block mt-3 hover:text-clinic-light transition-colors"
        >
          {BUSINESS.email}
        </a>
      </address>
      <div className="text-sm">
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-clinic-light mb-4">
          Medici Competenti
        </p>
        {DOCTORS.map((d) => (
          <p key={d.id} className="mb-2">
            {d.name}
          </p>
        ))}
        <nav className="mt-6 flex flex-col gap-2" aria-label="Link footer">
          <Link to="/#servizi" data-testid="footer-link-servizi" className="hover:text-clinic-light transition-colors">
            Servizi
          </Link>
          <Link to="/#faq" data-testid="footer-link-faq" className="hover:text-clinic-light transition-colors">
            Domande frequenti
          </Link>
          <Link to="/blog" data-testid="footer-link-blog" className="hover:text-clinic-light transition-colors">
            Blog
          </Link>
        </nav>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2 font-mono text-[10px] tracking-[0.15em] uppercase text-paper/40">
        <span>© 2026 {BUSINESS.shortName} — Studio di Medicina del Lavoro</span>
        <span>Roma · D.Lgs 81/08</span>
      </div>
    </div>
  </footer>
);
